<div class="Modal_Popup">
  <div class="Modal_Popup_Content">
    <div class="Popup_Message">
      <div class="Popup_Message_Content">
        <div class="Message_Title">Titulo</div>
        <div class="Message_Content">Conteúdo</div>
        <div class="Button_Container">
          <button class="Button_Ok" (click)="close()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>